import { QuestionData } from "@/components/quiz/typesAndEnums";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface QuestionGridProps {
  questions: QuestionData[];
  currentIndex: number;
  currentProgress: Record<string, any>;
  isEnded: boolean;
  setCurrentIndex: (index: number) => void;
  calculateGridBoxClassName: (question: QuestionData, index: number) => string;
  handleSubmitQuiz: () => void;
  isSubmitDisabled: boolean;
  isSubmitPending: boolean;
  SubmitButtonContent?: React.ReactNode;
}

const QuestionGrid = ({
  questions,
  currentIndex,
  currentProgress,
  isEnded,
  setCurrentIndex,
  calculateGridBoxClassName,
  handleSubmitQuiz,
  isSubmitDisabled,
  isSubmitPending,
  SubmitButtonContent,
}: QuestionGridProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">الأسئلة</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-5">
        <div className="grid sm:grid-cols-3 grid-cols-5 gap-2">
          {questions.map((q, index) => (
            <button
              key={`grid-btn-${q.question_id}-${index}`}
              onClick={() => setCurrentIndex(index)}
              className={`aspect-square rounded-lg flex items-center justify-center text-sm font-medium transition-colors cursor-pointer ${calculateGridBoxClassName(
                q,
                index
              )}`}
            >
              {index + 1}
            </button>
          ))}
        </div>
        <Button onClick={handleSubmitQuiz} disabled={isSubmitDisabled}>
          {SubmitButtonContent ?? (isSubmitPending ? "..." : "تسليم الإمتحان")}
        </Button>
      </CardContent>
    </Card>
  );
};

export default QuestionGrid;
